import { viewWithIdSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const getProductivityDashboardView = {
  name: "getProductivityDashboardView" as const,
  input: z.object({}),
  output: z.object({ view: viewWithIdSchemas["productivity-dashboard"] }),
};
